import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-ln-arrow-back-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-arrow-back-svg-icon.component.html',
  styleUrl: './ln-arrow-back-svg-icon.component.css',
})
export class LnArrowBackSvgIconComponent {
  @Input() class = 'w-8 h-8';
}
